import { PHONE_E164 } from "./limits.ts";

/**
 * Normalises user input to E.164. Vietnamese numbers may be typed as
 * 0901234567, 84901234567, +84 901 234 567 or 0084…; anything else must
 * already carry a + country code. Returns null when it cannot be a mobile
 * number we would send SMS to.
 */
export function normalizePhone(input: string): string | null {
  let s = input.trim().replace(/[\s().-]/g, "");
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  if (/^0[1-9]\d{8}$/.test(s))
    s = `+84${s.slice(1)}`; // VN local 10-digit
  else if (/^84[1-9]\d{8}$/.test(s)) s = `+${s}`;
  if (!PHONE_E164.test(s)) return null;
  if (s.startsWith("+84")) {
    // VN mobile: +84 then 9 digits starting 3, 5, 7, 8 or 9
    if (!/^\+84[35789]\d{8}$/.test(s)) return null;
  }
  return s;
}

export function isVietnamese(phone: string): boolean {
  return phone.startsWith("+84");
}

/** +84901234567 → 0901 234 567 (display only). */
export function formatPhone(phone: string): string {
  if (isVietnamese(phone)) {
    const local = `0${phone.slice(3)}`;
    return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
  }
  return phone;
}
